module.exports = __webpack_public_path__ + "static/media/karneveljen.dc205c02.png";